import { useCallback, useEffect, useState } from "react";
import { getProductCategories } from "../services/wooCommerceApi";
import { WordPressApiError } from "../services/wordpressClient";
import { isWordPressConfigured } from "../constants/wordpress";

let cachedCategories = null;
let categoriesPromise = null;

async function loadCategoriesOnce() {
  if (cachedCategories) {
    return cachedCategories;
  }

  if (!categoriesPromise) {
    categoriesPromise = getProductCategories()
      .then((data) => {
        cachedCategories = data;
        return data;
      })
      .catch((err) => {
        categoriesPromise = null;
        throw err;
      });
  }

  return categoriesPromise;
}

export function useProductCategories() {
  const [categories, setCategories] = useState(cachedCategories || []);
  const [loading, setLoading] = useState(!cachedCategories);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    if (!isWordPressConfigured()) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await loadCategoriesOnce();
      setCategories(data);
    } catch (err) {
      setError(
        err instanceof WordPressApiError ? err.message : "Failed to load categories.",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return { categories, loading, error, refetch: fetchCategories };
}
